import { Flex, Stack, Switch, Text } from '@mantine/core';

type Visibility = 'visible' | 'none';
interface ControlPanelProps {
  unescoState: [Visibility, React.Dispatch<React.SetStateAction<Visibility>>];
  wineRegionState: [Visibility, React.Dispatch<React.SetStateAction<Visibility>>];
  countriesState: [Visibility, React.Dispatch<React.SetStateAction<Visibility>>];
  citiesState: [Visibility, React.Dispatch<React.SetStateAction<Visibility>>];
}

function ControlPanel({ unescoState, wineRegionState, countriesState, citiesState }: ControlPanelProps) {
  const [enableUnesco, setEnableUnesco] = unescoState;
  const [enableWineRegion, setWineRegion] = wineRegionState;
  const [enableCounties, setEnableCountries] = countriesState;
  const [enableCities, setEnableCities] = citiesState;

  const toggleUnesco = () => {
    if (enableUnesco === 'visible') setEnableUnesco('none');
    else setEnableUnesco('visible');
  };
  const toggleWineRegions = () => {
    if (enableWineRegion === 'visible') setWineRegion('none');
    else setWineRegion('visible');
  };
  const toggleCountries = () => {
    if (enableCounties === 'visible') setEnableCountries('none');
    else setEnableCountries('visible');
  };
  const toggleCities = () => {
    if (enableCities === 'visible') setEnableCities('none');
    else setEnableCities('visible');
  };

  return (
    <Flex direction="column">
      <Text fw={700} pt={10}>
        Layer Controls
      </Text>
      <Stack mt="1rem">
        <Switch label="UNESCO Heritage Sites" checked={enableUnesco === 'visible'} onChange={toggleUnesco} />
        <Switch label="Major Cities" checked={enableCities === 'visible'} onChange={toggleCities} />
        <Switch label="Wine Regions" checked={enableWineRegion === 'visible'} onChange={toggleWineRegions} />
        <Switch label="Countries" checked={enableCounties === 'visible'} onChange={toggleCountries} />
      </Stack>
    </Flex>
  );
}

export default ControlPanel;
